import React, { Component } from 'react'
import { Redirect, Link } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { graphql } from 'react-apollo'
import { Form, Button, Row, Col, Spin, Tag } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import _get from 'lodash/get'
import moment from 'moment'

import RegistrationSteps from '~/App/components/RegistrationSteps'
import registrationQuery from '~/App/graphql/queries/registration.gql'
import payRegistrationMutation from '~/App/graphql/mutations/payRegistration.gql'
import localeGet from '~/App/utils/localeGet'
import Linepay from '~/App/components/PaymentBlocks/Linepay'
import OmiseCard from '~/App/components/PaymentBlocks/OmiseCard'
import OmiseTesco from '~/App/components/PaymentBlocks/OmiseTesco'
import OmiseNetbank from '~/App/components/PaymentBlocks/OmiseNetbank'
import OmiseAlipay from '~/App/components/PaymentBlocks/OmiseAlipay'
import OmiseTruemoney from '~/App/components/PaymentBlocks/OmiseTruemoney'
import Transfer from '~/App/components/PaymentBlocks/Transfer'
import PayatallCash from '~/App/components/PaymentBlocks/PayatallCash'
import ScbQr from '~/App/components/PaymentBlocks/ScbQr'
import ScbSlip from '~/App/components/PaymentBlocks/ScbSlip'
import './styles.css'

@injectIntl
@inject('i18n')
@observer
@graphql(registrationQuery, {
  options: ({ match: { params: { id } } }) => ({
    variables: { _id: id },
    fetchPolicy: 'network-only'
  })
})
@graphql(payRegistrationMutation, {
  name: 'payRegistration'
})
class RegistrationPayment extends Component {

  UNSAFE_componentWillReceiveProps (nextProps) { // eslint-disable-line
    const { data } = nextProps
    const _id = _get(data, 'registration._id')
    const event = _get(data, 'registration.event')
    const expired = _get(data, 'registration.expired')
    const status = _get(data, 'registration.status')
    const periods = _get(event, 'periods', [])
    // const preRegisterPeriod = _get(event, 'preRegisterPeriod')
    const currentPeriod = periods.find(period =>
      moment().isBetween(period.start, period.end) || moment().isBetween(period.preRegisterStart, period.preRegisterEnd)
    )
    // const registerPeriod = periods.find(p => !p.preRegister)
    const isPreRegister = currentPeriod && moment().isBetween(currentPeriod.preRegisterStart, currentPeriod.preRegisterEnd)
    // console.log({ status, _id })
    // const preRegisterOpen = currentPeriod && currentPeriod.preRegister
    if (status === 'paid') {
      return this.props.history.replace(`/reg/${_id}`)
    }
    if (!['submitted', 'accepted', 'paid'].includes(status) || expired || isPreRegister) {
      if (event) {
        const { slug } = event
        this.props.history.replace(`/${slug}`)
      } else {
        this.props.history.replace(`/`)
      }
    }
  }
  
  render () {
    const { data, i18n: { locale } } = this.props
    const { registration, loading } = data
    const expireAt = _get(data, 'registration.expireAt')
    
    if (loading) {
      return <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>
    } else if (!registration) {
      return <div>Registration Not found</div>
    }
    const { participants } = registration
    const { paymentQuotaExceeded } = registration

    const { status, amount, itemsAmount } = registration
    const discounted = _get(amount, 'discounted', 0)
    const itemsDiscounted = _get(itemsAmount, 'discounted', 0)
    const customMessage = _get(
      registration,
      'event.settings.payment.customMessage'
    )
    const ticketCount = participants.reduce((count, participant) =>
      count + participant.tickets.length
      , 0
    )

    const systemFee = _get(registration, 'event.settings.registration.fee', 0)
    const totalSystemFee = systemFee * ticketCount

    const enabledMethods = _get(registration, 'event.settings.payment.methods', [])
      .filter(method => method.enabled).reduce((methods, item) => {
        methods[item.method] = item
        return methods
      }, {})
    const gatewayFeesMap = _get(registration, 'event.settings.payment.gatewayFees', [])
      .reduce((map, item) => {
        map[item.gateway] = item.fee
        return map
      }, {})

    const bankAccountInfo = _get(
      registration,
      'event.settings.payment.bankAccountInfo'
    )

    return status && status === 'paid'
      ? <Redirect to={`/reg/${registration._id}`} />
      : <div>
        <Form onSubmit={this.handlePreviewRegistration} className="EventRegisterPage">
          {_get(registration, 'event.testMode') && <div className="testMode">
            <Tag color="red">
              Test mode !!!
            </Tag>
          </div>}
          <div className="innerEventRegisterPage">
            <div className="dividedBox">
              <div className="registrationTopTitle">
                {localeGet(data, 'registration.event.name', locale)}
              </div>
              <RegistrationSteps step="pay" />
            </div>
            <div className="dividedBox">
              {paymentQuotaExceeded
                ? <div style={{ textAlign: 'center' }}>
                    <Tag color="red" style={{fontSize: '19px'}}>
                      <FormattedMessage id="api.QUOTA_EXCEEDED" />
                    </Tag>
                  </div>
                : <div>
                  <h1><FormattedMessage id="app.selectPaymentMethod" defaultMessage="Select payment method"/></h1>
                  <div style={{paddingBottom: '8px'}}>
                    {{
                      en: 'Reg. No.',
                      th: 'รหัสใบสมัคร'
                    }[locale]}: {registration.code}
                  </div>
                  {customMessage &&
                <blockquote style={{ textAlign: 'center' }}>
                  {localeGet(customMessage, '', locale)}
                </blockquote>
                  }
                  
                <Row type="flex" justify="center" gutter={16} style={{ textAlign: 'center' }}>
                  {enabledMethods['omise_truemoney'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <OmiseTruemoney
                      registration={registration}
                      discounted={discounted}
                      gatewayRate={gatewayFeesMap['omise']}
                      gatewaySettings={enabledMethods['omise_truemoney']}
                      systemFee={systemFee}
                      totalSystemFee={totalSystemFee}
                      itemsDiscounted={itemsDiscounted}
                    />
                  </Col>}
                  {enabledMethods['scb_qr'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <ScbQr
                      registration={registration}
                      discounted={discounted}
                      gatewayRate={gatewayFeesMap['scb']}
                      gatewaySettings={enabledMethods['scb_qr']}
                      systemFee={systemFee}
                      totalSystemFee={totalSystemFee}
                      itemsDiscounted={itemsDiscounted}
                    />
                  </Col>}
                  {enabledMethods['scb_slip'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <ScbSlip
                      registration={registration}
                      discounted={discounted}
                      gatewayRate={gatewayFeesMap['scb']}
                      gatewaySettings={enabledMethods['scb_slip']}
                      systemFee={systemFee}
                      totalSystemFee={totalSystemFee}
                      itemsDiscounted={itemsDiscounted}
                    />
                  </Col>}
                  {enabledMethods['omise_card'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <OmiseCard
                      registration={registration}
                      discounted={discounted}
                      gatewayRate={gatewayFeesMap['omise']}
                      gatewaySettings={enabledMethods['omise_card']}
                      systemFee={systemFee}
                      totalSystemFee={totalSystemFee}
                      itemsDiscounted={itemsDiscounted}
                    />
                  </Col>}
                  {enabledMethods['linepay'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <Linepay
                      registration={registration}
                      discounted={discounted}
                      gatewayRate={gatewayFeesMap['linepay']}
                      gatewaySettings={enabledMethods['linepay']}
                      systemFee={systemFee}
                      totalSystemFee={totalSystemFee}
                      itemsDiscounted={itemsDiscounted}
                    />
                  </Col>}
                  {enabledMethods['omise_tesco'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <OmiseTesco
                      registration={registration}
                      discounted={discounted}
                      gatewayRate={gatewayFeesMap['omise']}
                      gatewaySettings={enabledMethods['omise_tesco']}
                      systemFee={systemFee}
                      totalSystemFee={totalSystemFee}
                      itemsDiscounted={itemsDiscounted}
                    />
                  </Col>}
                  {enabledMethods['omise_netbank'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <React.Suspense fallback={<div className="modLoadding">
                      <Spin tip="Loading..." size="large" />
                    </div>}>
                      <OmiseNetbank
                        registration={registration}
                        discounted={discounted}
                        gatewayRate={gatewayFeesMap['omise']}
                        gatewaySettings={enabledMethods['omise_netbank']}
                        systemFee={systemFee}
                        totalSystemFee={totalSystemFee}
                        itemsDiscounted={itemsDiscounted}
                      />
                    </React.Suspense>
                  </Col>}
                  {enabledMethods['omise_alipay'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <OmiseAlipay
                      registration={registration}
                      discounted={discounted}
                      gatewayRate={gatewayFeesMap['omise']}
                      gatewaySettings={enabledMethods['omise_alipay']}
                      systemFee={systemFee}
                      totalSystemFee={totalSystemFee}
                      itemsDiscounted={itemsDiscounted}
                    />
                  </Col>}
                  {enabledMethods['transfer'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <Transfer
                      registration={registration}
                      discounted={discounted}
                      gatewayRate={gatewayFeesMap['transfer']}
                      gatewaySettings={enabledMethods['transfer']}
                      systemFee={systemFee}
                      totalSystemFee={totalSystemFee}
                      itemsDiscounted={itemsDiscounted}
                      bankAccountInfo={bankAccountInfo}
                    />
                  </Col>}
                  {enabledMethods['payatall_cash'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <PayatallCash
                      registration={registration}
                      discounted={discounted}
                      gatewayRate={gatewayFeesMap['payatall']}
                      gatewaySettings={enabledMethods['payatall_cash']}
                      systemFee={systemFee}
                      totalSystemFee={totalSystemFee}
                      itemsDiscounted={itemsDiscounted}
                    />
                  </Col>}
                </Row>
              </div>
              }
              <div style={{ padding: '8px', textAlign: 'right' }}>
                {!paymentQuotaExceeded &&<FormattedMessage id="app.payLater" values={{ expireAt: moment(expireAt).format('Do MMMM HH:mm') }} defaultMessage="Dashboard" />}{' '}
                <Link to="/dashboard">
                  <Button type="primary" ><FormattedMessage id="app.backToDashBoard" defaultMessage="Dashboard" /></Button>
                </Link>{' '}
                <Link to={`/${registration.event.slug}`}>
                  <Button type="primary" ><FormattedMessage id="app.backToEventPage" defaultMessage="To Event" /></Button>
                </Link>
              </div>
            </div>
          </div>
        </Form>
      </div>
  }
}
export default RegistrationPayment

// TODO: transfor props get rid of data



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/RegistrationPayment/RegistrationPayment.js